import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/Login/desktop';
import Mobile from 'pages/Login/mobile';
import { PageContext } from 'pages/Login/PageProvider';
import Tablet from 'pages/Login/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { device } = useViewport();
    const { loading: authLoading, auth } = useAuth();
    const { loading: loginPageLoading } = useContext(PageContext);

    const props = {};

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    if (auth || authLoading || loginPageLoading) return <Loading />;

    return renderResponsiveLayout(device);
};

export default PageLayout;
